import ImageSlider from "./ImageSlider";

export default ImageSlider;